import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import DisposeReadonlyValue from './dispose-readonly-value.vue'
import { ApplyScope } from '../constants/enums'
import { trEventTypeDisplay, trListEventLevel, listLevelColor } from '../labels'
import type { SecurityEventDetail } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'dispose-trust-context-form',
  props: {
    detail: {},
    showApplyScope: { type: Boolean },
    applyScope: {}
  },
  emits: ["update:applyScope"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()

// 翻译 securityEvent.* 前缀的 i18n key（与 G6 图 displayText 一致）
function displayText (value?: string): string {
  if (!value) return ''
  return value.startsWith('securityEvent.') ? t(value) : value
}

const eventDescText = computed(() => displayText(props.detail.event_desc))

const riskLevelText = computed(() => trListEventLevel(t, props.detail.event_level))

const eventTypeText = computed(() => trEventTypeDisplay(t, props.detail))

/** 事件描述与事件类型重复时隐藏描述字段 */
const showEventDesc = computed(() => {
  const desc = eventDescText.value
  if (!desc) return false
  return desc !== eventTypeText.value
})

const eventOperatorText = computed(() => displayText([...new Set(props.detail.event_operator?.split?.(','))]+''))
const eventTargetValue = computed(() => {
  const raw = props.detail.event_target || props.detail.threat_entity || props.detail.trust_display_text
  // 可能包含逗号分隔的多个名称，逐个翻译
  return raw ? raw.split(', ').map((s) => displayText(s)).join(', ') : ''
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "left",
    "label-width": "auto",
    size: "small",
    class: "dispose-form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('securityEvent.labelRiskLevel')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tag, {
            size: "small",
            type: _unref(listLevelColor)(props.detail.event_level),
            effect: "plain"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(riskLevelText.value), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('securityEvent.colEventType')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tag, {
            size: "small",
            effect: "plain",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(eventTypeText.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      (showEventDesc.value)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _ctx.$t('securityEvent.colDescription')
          }, {
            default: _withCtx(() => [
              _createVNode(DisposeReadonlyValue, {
                value: eventDescText.value,
                multiline: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('securityEvent.labelEventOperator')
      }, {
        default: _withCtx(() => [
          _createVNode(DisposeReadonlyValue, { value: eventOperatorText.value }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('securityEvent.labelEventTarget')
      }, {
        default: _withCtx(() => [
          _createVNode(DisposeReadonlyValue, {
            value: eventTargetValue.value,
            multiline: ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.showApplyScope)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: _ctx.$t('securityEvent.applyScope')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                "model-value": _ctx.applyScope,
                size: "small",
                style: {"width":"240px"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:applyScope', $event)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('securityEvent.scopeLocal'),
                    value: _unref(ApplyScope).Local
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('securityEvent.scopeAll'),
                    value: _unref(ApplyScope).AllEndpoints
                  }, null, 8, ["label", "value"])
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})